import React from 'react';
import PropTypes from 'prop-types';
import Details from '@eg/elements/Details';
import { legalConsentProps } from '../../../models/panels';
import { getContactDataPolicyholder, getSMelder } from '../../../helpers/formData/assetLiabilityFormData';
import { SvgKontaktdatenDesUnfallbeteiligten } from '../../../helpers/IconLoader';

const ContactDetailsPolicyholder = ({ formData, localePath, className }, { t }) => {
  const data = getContactDataPolicyholder(formData);

  const isSMelder = getSMelder(formData);
  if (isSMelder) return false;

  return (
    <Details
      iconLeft={SvgKontaktdatenDesUnfallbeteiligten}
      summary={t(`${localePath}.contact.title-policyholder`)}
      className={className}
    >
      <p>
        {t(`${localePath}.contact.content-name`, {
          firstName: data.firstName,
          lastName: data.lastName,
        })}
      </p>
      <p>
        {t(`${localePath}.contact.content-phone`, {
          phone: data.phone,
        })}
      </p>
      <p>
        {t(`${localePath}.contact.content-email`, {
          email: data.email,
        })}
      </p>
    </Details>
  );
};

ContactDetailsPolicyholder.propTypes = legalConsentProps.sectionProps;
ContactDetailsPolicyholder.defaultProps = legalConsentProps.sectionDefaults;

ContactDetailsPolicyholder.contextTypes = {
  t: PropTypes.func,
};

export default ContactDetailsPolicyholder;
